import Api from "./Api";

class GraphService {
    get = async () => {
        return await Api().get(`graphs`)
    };
}

export default new GraphService();